/**
 * @file BrandLogoDraw.tsx
 * @brief Verblizr mark that strokes its outline, then fills — used by the
 *        boot FullScreenLoader.
 *
 * @details
 * Paths come from the official mark (`FRONTEND/src/assets/icons/logosvg.svg`,
 * mirrored at `public/brand/logosvg.svg`). Animation CSS lives in
 * `index.css` (`.brand-logo-draw__path`) so it is not dependent on
 * Tailwind config HMR. `pathLength={1}` normalizes the dash length.
 *
 * @author DES
 * @date 17-07-2026
 */

import { cn } from "@/shared/theme/cn";

/** Outer helmet / C-shape from logosvg.svg */
export const HELMET_PATH =
  "M783.89,527.79c15.52-2.65,28.13,12.37,22.88,27.21-19.02,53.73-49.66,104.33-91.91,148.33-43.65,45.25-95.05,78.62-150.19,99.97-5.39,2.09-9.67-4.85-5.39-8.73,5.99-5.43,11.84-11.09,17.49-16.95,34.03-35.54,59-76.3,74.8-119.66,5-13.73-6.64-27.75-21.04-25.25l-74.25,12.87c-31.44,5.36-56.82-24.45-45.41-52.63l82.16-224.77c7.98-21.83,3.18-46.39-12.7-63.36-4.21-4.5-8.57-8.9-13.1-13.21-136.7-131.57-354.44-127.15-485.78,9.55-31.64,32.97-55.47,70.62-71.39,110.65-2.14,5.37-10.13,3.73-10.05-2.06,1.32-101.78,39.78-203.22,115.9-282.32,159.05-165.34,422.2-170.46,587.54-11.41,7.15,6.85,14.01,13.91,20.56,21.16,16.12,17.83,20.84,43.23,12.59,65.81l-101.38,277.25c-13.74,34,17,70.33,54.96,63.58l93.72-16.02Z";

/** Inner play triangle from logosvg.svg */
export const PLAY_PATH =
  "M239.45,479.07l-.82-113.6c-.1-13.17,13.84-21.5,24.59-15l99.19,56.09c11.57,6.5,11.7,23.79.22,30.46l-98.37,57.51c-10.66,5.84-24.71-2.29-24.81-15.46Z";

interface BrandLogoDrawProps {
  className?: string;
  /** Pixel size for both width and height (default 80). */
  size?: number;
}

export function BrandLogoDraw({ className, size = 80 }: BrandLogoDrawProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 807.98 803.69"
      width={size}
      height={size}
      fill="none"
      aria-hidden
      className={cn("block shrink-0 overflow-visible", className)}
    >
      <path className="brand-logo-draw__path" pathLength={1} d={HELMET_PATH} />
      <path
        className="brand-logo-draw__path brand-logo-draw__path--delayed"
        pathLength={1}
        d={PLAY_PATH}
      />
    </svg>
  );
}
